<template>
  <div class="main-wrapper login-body">
    <header class="log-header">
      <router-link to="/home/">
        <img class="img-fluid logo-dark" src="@/assets/img/logo.ad0b8567.png" alt="الشعار" />
      </router-link>
    </header>

    <div class="login-wrapper">
      <div class="loginbox">
        <div class="login-auth">
          <div class="login-auth-wrap">
            <h1>إكمال الملف الشخصي</h1>
            <p class="account-subtitle">الرجاء إدخال البيانات المطلوبة.</p>

            <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }">
              <div class="input-block">
                <label class="form-label">الاسم <span class="text-danger">*</span></label>
                <Field name="name" type="text" class="form-control" :class="{ 'is-invalid': errors.name }" placeholder="الاسم" />
                <div class="invalid-feedback">{{ errors.name }}</div>
              </div>

              <div class="input-block mt-3">
                <label class="form-label">البريد الإلكتروني</label>
                <Field name="email" type="email" class="form-control" :class="{ 'is-invalid': errors.email }" placeholder="example@mail.com" />
                <div class="invalid-feedback">{{ errors.email }}</div>
              </div>

              <div class="input-block mt-3">
                <label class="form-label">كلمة المرور <span class="text-danger">*</span></label>
                <div class="pass-group">
                  <Field name="password" :type="showPassword ? 'text' : 'password'" class="form-control pass-input" placeholder="كلمة المرور" :class="{ 'is-invalid': errors.password }" />
                  <span @click="toggleShow" class="toggle-password">
                    <i :class="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                  </span>
                  <div class="invalid-feedback">{{ errors.password }}</div>
                </div>
              </div>
              <div class="input-block mt-3">
                <label class="form-label">النوع <span class="text-danger">*</span></label>
                <div>
                  <label class="me-3">
                    <Field type="radio" name="type" value="individual" />
                    فردي
                  </label>
                  <label>
                    <Field type="radio" name="type" value="agency" />
                    معرض / وكالة
                  </label>
                </div>
                <div class="invalid-feedback">{{ errors.type }}</div>
              </div>
              <b-button class="primary btn-block mt-3" type="submit" :disabled="auth.isLoading">
                {{ auth.isLoading ? 'جارٍ التحميل...' : 'حفظ البيانات' }}
              </b-button>
            </Form>
          </div>
        </div>
      </div>
    </div>

    <auth-footer></auth-footer>
  </div>
</template>

<script>
import { ref } from "vue";
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import { useAuthStore } from "@/stores/auth";
import { useRouter } from "vue-router";

export default {
  components: { Form, Field },
  setup() {
    const auth = useAuthStore();
    const router = useRouter();
    const showPassword = ref(false);
    const toggleShow = () => (showPassword.value = !showPassword.value);

   const schema = Yup.object().shape({
      name: Yup.string().required("الاسم مطلوب"),
      email: Yup.string().email("صيغة البريد غير صحيحة").nullable(),
      password: Yup.string()
        .min(5, "كلمة المرور يجب ألا تقل عن 6 أحرف")
        .required("كلمة المرور مطلوبة"),
      type: Yup.string().oneOf(["individual", "agency"], "النوع مطلوب").required("النوع مطلوب"),
    });


    const onSubmit = async (values) => {
      const success = await auth.completeProfile(values);
      if (success) {
        router.push("/index-5");
      }
    };

    return { showPassword, toggleShow, schema, onSubmit, auth };
  },
};
</script>

<style scoped>
.logo-dark {
  width: 150px;
  height: auto;
}
</style>
